export const Logo = ({ size = 84 }) => (
  <img
    src="/kaveribiz_logo.png"
    alt="KaveriBiz"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className="object-contain shrink-0"
    data-testid="kb-logo"
  />
);
